<template>
  <Modal
    v-model="_value"
    width="500"
    title="JT808设置疲劳驾驶预警差值"
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
    <Form :model="reqParams" :label-width="80">
      <FormItem prop="terminalNum" label="主机号">
        <Input v-model="reqParams.terminalNum" placeholder="请输入主机号">
        </Input>
      </FormItem>
      <FormItem prop="terminalNum" label="主机号列表">
        <Input v-model="reqParams.terminalNums" placeholder="请输入主机号列表">
        </Input>
      </FormItem>
      <FormItem prop="fatigueDrivingAlarmDifference" label="疲劳驾驶预警差值">
        <Input v-model="reqParams.fatigueDrivingAlarmDifference" placeholder="请输入疲劳驾驶预警差值">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'jt808setfatiguedrivingalarmdifferencemodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        reqParams: {
          terminalNums:[],
          terminalNum:'',
          fatigueDrivingAlarmDifference:0
        }
      }
    },
    methods: {
      ...mapActions([
        'NetCommandServ_SetFatigueDrivingAlarmDifference',
        'NetCommandServ_BatchSetFatigueDrivingAlarmDifference',
      ]),
      onOk() {
        if (Array.isArray(this._initValue)){
          store.dispatch('NetCommandServ_BatchSetFatigueDrivingAlarmDifference', {
            params: this.reqParams
          }).then(() => {
            this.$Message.success('发送成功')
          }).catch(err => {
            this.$Message.error(err)
          })
        }else {
          store.dispatch('NetCommandServ_SetFatigueDrivingAlarmDifference', {
            params: this.reqParams
          }).then(() => {
            this.$Message.success('发送成功')
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      },
      visibleChange(val) {
        if(val){
          if (Array.isArray(this._initValue)){
            this.reqParams.terminalNums = this._initValue
          } else {
            this.reqParams.terminalNum = this._initValue
          }
          this.reqParams.fatigueDrivingAlarmDifference = 14400
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
